(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/payfooter/assets/javascripts/components/button-description.js') >= 0) return;  svs.modules.push('/components/tur/payfooter/assets/javascripts/components/button-description.js');
"use strict";


const ButtonWithDescription = _ref => {
  let button = _ref.button,
    description = _ref.description;
  const _description$content = description.content,
    content = _description$content === void 0 ? null : _description$content,
    _description$classNam = description.classNames,
    classNames = _description$classNam === void 0 ? 'payfooter-block center-text margin-1' : _description$classNam;
  return React.createElement(React.Fragment, null, button, content && React.createElement("div", {
    className: classNames
  }, content));
};
svs.tur.ReactPayfooter.ButtonWithDescription = ButtonWithDescription;

 })(window);